// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__37HQb","footer":"Form_footer__f8oSr"};